import React, { useState } from "react";
import { createPortal } from "react-dom";
import "../../styles/common/popup.scss";

const ChangePasswordPopup = ({ isOpen, onClose, onChangePassword }) => {
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errors, setErrors] = useState({});

  const validateForm = () => {
    const newErrors = {};

    if (!oldPassword) {
      newErrors.oldPassword = "Old password is required";
    }

    if (!newPassword) {
      newErrors.newPassword = "New password is required";
    } else if (newPassword.length < 6) {
      newErrors.newPassword = "New password must be at least 6 characters";
    } else if (newPassword === oldPassword) {
      newErrors.newPassword = "New password must be different from old password";
    }

    if (!confirmPassword) {
      newErrors.confirmPassword = "Confirm password is required";
    } else if (newPassword !== confirmPassword) {
      newErrors.confirmPassword = "Passwords do not match";
    }

    return newErrors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const newErrors = validateForm();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    onChangePassword({
      oldPassword,
      newPassword,
      confirmPassword,
    });

    setOldPassword("");
    setNewPassword("");
    setConfirmPassword("");
    setErrors({});
    onClose();
  };

  const handleClose = () => {
    setOldPassword("");
    setNewPassword("");
    setConfirmPassword("");
    setErrors({});
    onClose();
  };

  const handleInputChange = (field, value) => {
    if (errors[field]) {
      setErrors((prev) => ({ ...prev, [field]: "" }));
    }

    switch (field) {
      case "oldPassword":
        setOldPassword(value);
        break;
      case "newPassword":
        setNewPassword(value);
        break;
      case "confirmPassword":
        setConfirmPassword(value);
        break;
      default:
        break;
    }
  };

  return createPortal(
    <div
      className="common-popup-overlay high-z-index"
      role="dialog"
      aria-modal="true"
      onClick={handleClose}
    >
      <div
        className="common-popup-container"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="popup-header with-close">
          <h2>Change Password</h2>
          <button className="popup-close-button" onClick={handleClose}>
            ×
          </button>
        </div>
        <div className="popup-content">
          <form onSubmit={handleSubmit}>
            <div className="popup-form-group">
              <label>Old Password</label>
              <input
                type="password"
                value={oldPassword}
                onChange={(e) =>
                  handleInputChange("oldPassword", e.target.value)
                }
                className={`popup-input ${errors.oldPassword ? "error" : ""}`}
              />
              <div className="popup-error-message">
                {errors.oldPassword && <p>{errors.oldPassword}</p>}
              </div>
            </div>
            <div className="popup-form-group">
              <label>New Password</label>
              <input
                type="password"
                value={newPassword}
                onChange={(e) =>
                  handleInputChange("newPassword", e.target.value)
                }
                className={`popup-input ${errors.newPassword ? "error" : ""}`}
              />
              <p className="popup-help-text" style={{ fontSize: "11px", color: "var(--text-secondary, #6b7280)", marginTop: "4px" }}>
                Must be at least 6 characters.
              </p>
              <div className="popup-error-message">
                {errors.newPassword && <p>{errors.newPassword}</p>}
              </div>
            </div>
            <div className="popup-form-group">
              <label>Confirm New Password</label>
              <input
                type="password"
                value={confirmPassword}
                onChange={(e) =>
                  handleInputChange("confirmPassword", e.target.value)
                }
                className={`popup-input ${
                  errors.confirmPassword ? "error" : ""
                }`}
              />
              <div className="popup-error-message">
                {errors.confirmPassword && <p>{errors.confirmPassword}</p>}
              </div>
            </div>

            <div className="popup-actions">
              <button type="submit" className="popup-submit-button">
                Update Password
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default ChangePasswordPopup;
